import useCachedSelectionList from '../base/useCachedList';
import { useFindSpecialityForSelectionLazy } from './useFindSpecialityForSelection';

const useCachedSpecialitiesList = () => {
  return useCachedSelectionList(
    'specialityList',
    useFindSpecialityForSelectionLazy
  );
};

export default useCachedSpecialitiesList;
